export const ToolsMixin = {
  data() {
    return {}
  },

  methods: {
    trackScreenView(screenName) {
      this.$gtag.screenview({
        app_name: this.texts.general.productname,
        screen_name: screenName
      })
    },
    getText(path, defaultText = '') {
      return this._.get(
        this.$store.state.decoupled.configFile.texts,
        path,
        defaultText
      )
    },
    getConfigParam(path, defaultValue = null) {
      return this._.get(
        this.$store.state.decoupled.configFile.config,
        path,
        defaultValue
      )
    },
    generateMatomoEventCategory(){
      return this.$route.query.utm_campaign ?  'user_register_' + this.$route.query.utm_campaign : 'user_register'
    }
  }
}
